import React, { useState } from 'react';
import { Card, Space, Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import EditorCard from '../content/editorCard';
import ImageWithSpinner from '../content/imagewithspinner';
import ItemSelectionDrawer from '../content/itemselectiondrawer';
import { useAuth } from '../../auth/authcontext';

interface MenuItem {
    guid: string;
    menuGuid?: string;
    name: string;
    imageName?: string;
}

interface MenuItemsForGroupProps {
    menuItemsForGroup: MenuItem[];
    onAddMenuItem?: (menuItemGuid: string) => Promise<void> | void;
    onRemoveMenuItem?: (menuItemGuid: string) => Promise<void> | void;
}

const MenuItemsForGroup: React.FC<MenuItemsForGroupProps> = ({ 
    menuItemsForGroup,
    onAddMenuItem,
    onRemoveMenuItem
}) => {
    const { isReadOnly } = useAuth();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    return (
        <>
            <EditorCard 
                title="Items Assigned to this Group"
                extra={onAddMenuItem ? (
                    <Button 
                        color="green"
                        variant="solid"
                        size="small"
                        onClick={() => setIsDrawerOpen(true)}
                    >
                        Add
                    </Button>
                ) : undefined}
            >
                {menuItemsForGroup?.length > 0 ? (
                    menuItemsForGroup.map((option) => (
                        <Card
                            key={option.guid}
                            size="small"
                            style={{
                                marginBottom: '8px',
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
                            }}
                            styles={{
                                body: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    width: '100%',
                                    padding: '8px 12px',
                                }
                            }}
                        >
                            <Space>
                                <div style={{ marginRight: '10px', width: '50px', height: '50px' }}>
                                    {option.imageName && <ImageWithSpinner imageUrl={option.imageName} />}
                                </div>
                                <div>{option.name}</div>
                            </Space>
                            {(!isReadOnly && onRemoveMenuItem) && (
                                <Popconfirm
                                    title="Are you sure you want to remove this item from the group?"
                                    onConfirm={() => onRemoveMenuItem(option.menuGuid!)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        type="text"
                                        danger
                                        icon={<DeleteOutlined />}
                                        style={{ marginLeft: 'auto' }}
                                    />
                                </Popconfirm>
                            )}
                        </Card>
                    ))
                ) : (
                    <>No Items are assigned to this group</>
                )}
            </EditorCard>
            <ItemSelectionDrawer
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                onAssign={onAddMenuItem || (() => {})}
            />
        </>
    );
};

export default MenuItemsForGroup;
